module.exports = __webpack_public_path__ + "img/imagen-duo.e372e816.svg";